/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import HousesAndTeamsIcon from 'icons/HousesAndTeamsIcon';

const messages = defineMessages({
  title: {id: 'navigation.houses-and-teams'},
});

const HousesAndTeamsItem = () => (
  <RouteLinkItem
    iconBefore={HousesAndTeamsIcon}
    route="midas/students/houses-and-teams"
    title={messages.title}
  />
);

export default HousesAndTeamsItem;
